import { useState } from 'react';
import './AnalyzeForm.css';

const SAMPLE_URLS = [
  {
    label: 'Authentic demo',
    url: 'https://images.unsplash.com/photo-1591189824344-9c4cc83a1aa3?w=1200&q=80',
  },
  {
    label: 'Manipulated demo',
    url: 'https://images.unsplash.com/photo-1518770660439-4636190af475?w=1200&q=80&hint=fake',
  },
  {
    label: 'CGI / not-a-photo demo',
    url: 'https://images.unsplash.com/photo-1633957897986-70e83293f3ff?w=1200&q=80&hint=cgi-render',
  },
];

export default function AnalyzeForm({ onSubmit, disabled, error }) {
  const [url, setUrl] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!url.trim() || disabled) return;
    onSubmit(url.trim());
  };

  return (
    <div className="analyze-form">
      <div className="analyze-form__head">
        <h1 className="analyze-form__title">
          <span className="analyze-form__title-serif">Submit a photo</span>
          <span className="analyze-form__title-mono">for credibility analysis</span>
        </h1>
        <p className="analyze-form__subtitle">
          Paste a public image URL. We score authenticity, detect manipulation, and check whether the
          scene matches its stated context.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="analyze-form__form">
        <div className="analyze-form__field">
          <label htmlFor="image-url" className="analyze-form__label">
            IMAGE URL
          </label>
          <div className="analyze-form__input-wrap">
            <input
              id="image-url"
              type="url"
              value={url}
              onChange={(e) => setUrl(e.target.value)}
              placeholder="https://…"
              disabled={disabled}
              autoFocus
              className="analyze-form__input"
            />
            <button
              type="submit"
              disabled={disabled || !url.trim()}
              className="analyze-form__submit"
            >
              {disabled ? 'ANALYZING…' : 'ANALYZE →'}
            </button>
          </div>
          {error && <div className="analyze-form__error">{error}</div>}
        </div>
      </form>

      <div className="analyze-form__samples">
        <div className="analyze-form__samples-label">{'// TRY A SAMPLE'}</div>
        <div className="analyze-form__samples-row">
          {SAMPLE_URLS.map((s) => (
            <button
              key={s.label}
              type="button"
              onClick={() => setUrl(s.url)}
              disabled={disabled}
              className="analyze-form__sample"
            >
              {s.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
